
import Question from './Question.vue'
import Message from './Message.vue'
import Process from './Process.vue'
import Buy from './Buy.vue'
import Measure from './Measure.vue'
import API from '../api'
import Window from '../utils/Window'
import URL from '../utils/URL'
import Cookie from '../utils/Cookie'
import qs from 'qs'
import cookie from 'vux/src/tools/cookie/index.js'


const code = URL.getQueryString('code')


let isYuandan = false
const now = Date.now()
const yuandan = new Date(2018, 0, 1).getTime()
if (now > yuandan) {
isYuandan = true
}


const jihuashu = cookie.get('jihuashu')

let playAudioTimer = null
export default {
data () {
return {
codeOK: false,
audioIsPlaying: false,
currentAudioTime: '',
showDetailDialog: false,
detailDialogTitle: '',
detailDialogTabs: [],
detailDialogItems: [],
currentDetailDialogIndex: 0,
measureState: false,
isShow: true,
inActivity: false,
showDetail: false,
activityId: '151019418799579',
isYuandan: isYuandan,
showAgent: false,
agentName: '',
agentJobNum: '',
isJihuashuGuideClicked: false,
jihuashuGuideIndex: 0,
jihuashuGuideImgs: [
'static/common/images/jihuashu_guide_1.png',
'static/common/images/jihuashu_guide_2.png',
'static/common/images/jihuashu_guide_3.png'
],
showShare: false,
njxOffline: false,
message: {
isShowSum: false,
totalNumber: ''
}
}
},
components: {
[Question.name]: Question,
[Message.name]: Message,
[Process.name]: Process,
[Buy.name]: Buy,
[Measure.name]: Measure
},
computed: {
urlsource () {
let tempurlsource = ''
if (this.$route.query.utm_source !== undefined) {
if (this.$route.query.utm_source === 'tab1') {
tempurlsource = 'tab1.d'
} else {
tempurlsource = this.$route.query.utm_source
}
tempurlsource = '?utm_source=' + tempurlsource
}
return tempurlsource
},
h5 () {
return this.$store.state.app.h5
},
tel () {
if (this.$store.state.config.serviceTel) {
return this.$store.state.config.serviceTel
}
return '400-661-2992'
},
showJihuashuGuide () {
if ((jihuashu !== 'hasShowed') && !this.isWKB && !this.h5 && (['150476691002746473', '150537492578996275', '150570517523511386', '150546537968917914'].indexOf(this.$store.state.app.productCode) !== -1)) {
return true
}
return false
},
isWKB () {
if (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) === -1) {
return false
}
return true
},
isWX () {
return Window.isWX()
},
inActTime () {
const start = new Date(2018, 9, 1)
const end = new Date(2018, 9, 30)
const now = new Date()
if (now >= start && now <= end) {
return true
}
return false
},
isActivityProducts () {
if (['150476691002746473', '150537492578996275', '151013300258317638', '151072428587363110', '150831059068987214', '150840325766681140'].indexOf(this.$store.state.app.productCode) === -1) {
return false
}
return true
},
isNjx () {
if (['151013300258317638', '151072428587363110'].indexOf(this.$store.state.app.productCode) === -1) {
return false
}
return true
},
isProspectus () {
const isProspectus = this.$route.query.isProspectus
if (isProspectus !== undefined) return true
return false
},
activityURL () {
return window.location.protocol + '//' + window.location.hostname + '/anniversaries/2018/jixiangsanbao'
},
title () {
if (this.$store.state.config.title) {

if (this.h5) {
document.title = this.$store.state.config.title
} else {
API.getUserName(this).then(response => {
document.title = response + '推荐：' + this.$store.state.config.title
})
}
}
},
banner () {
if (this.$store.state.config.banner) {
return this.$store.state.config.banner + '?productCode=' + this.$store.state.app.productCode + '&innerCode=' + this.$store.state.app.innerCode + '&utm_source=' + (this.$route.query.utm_source || '')
}
},
partners () {
if (this.$store.state.config.partners) {
return this.$store.state.config.partners
}
},
partnersOne () {

if (['150476691002746473', '150537492578996275'].indexOf(this.$store.state.app.productCode) !== -1 && this.isDailiren) {
return true
}
return false
},
themeColor () {
if (this.$store.state.config.themeColor) {
return this.$store.state.config.themeColor
}
},
voice () {
if (this.$store.state.config.voice) {
return this.$store.state.config.voice
}
},
voiceIcon () {
if (this.$store.state.config.voice) {
return this.$store.state.config.voice.icon
}
},
wxIcon () {
if (this.audioIsPlaying) {
return 'static/common/images/wx_voice_on.gif'
}
return 'static/common/images/wx_voice_off.png'
},
voiceTitle () {
if (this.$store.state.config.voice) {
return this.$store.state.config.voice.title
}
},
voiceSubtitle () {
if (this.$store.state.config.voice) {
return this.$store.state.config.voice.subtitle
}
},
onOff () {
if (this.audioIsPlaying) {
return 'static/common/images/on.png'
}
return 'static/common/images/off.svg'
},
voiceUrl () {
if (this.$store.state.config.voice) {
return this.$store.state.config.voice.url
}
},
introduction () {
if (this.$store.state.config.introduction) {
return this.$store.state.config.introduction
}
},
introBtns () {
if (this.$store.state.config.introBtns) {
return this.$store.state.config.introBtns
}
},
questions () {
if (this.$store.state.config.questions) {
return this.$store.state.config.questions
}
},
hasMeasure () {
if (this.$store.state.config.measure) {
return this.$store.state.config.measure.status
}
return false
},
hasNotify () {
if (this.$store.state.config.notifies) {
return this.$store.state.config.notifies.status
}
return false
},
isDailiren () {



const isWKB = ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1
if (!this.h5 && !isWKB) {
return true
}
return false
},
showShareProducts () {
return ['150476691002746473', '150537492578996275'].indexOf(this.$store.state.app.productCode) !== -1
}
},
filters: {
formatAudioTime (onlySecond) {
const duration = Math.floor(onlySecond)
let minute = Math.floor(duration / 60)
minute = minute < 10 ? ('0' + minute) : minute
let second = duration % 60
second = second < 10 ? ('0' + second) : second
return minute + ':' + second
}
},
created () {

const njxOfflineBegin = new Date(2018, 5, 20, 19)
const njxOfflineEnd = new Date(2018, 5, 22, 11)
const njxNow = Date.now()
if (this.isNjx && njxNow >= njxOfflineBegin && njxNow <= njxOfflineEnd) {
this.$data.njxOffline = true
this.$vux.alert.show({
title: '产品升级',
content: '抱歉，产品升级维护中，您暂时无法购买，升级时间2018.6.20 19:00-2018.6.22 11:00',
buttonText: '我知道了',
onShow () {
}
})
}


if (this.$route.query.showShare === 'true') {
this.showShare = true
}


const agentCode = this.$route.query.agentCode
const supAgentCode = this.$route.query.supAgentCode
if (Window.isWX() && this.h5 && (agentCode === undefined || agentCode === null || agentCode === '') && supAgentCode === 'true') {
this.showAgent = true
}


this.$http('/api/activityNoLogin/getActivityStatus?activityCode=' + this.activityId).then(response => {
if (response.data.resultCode === 'error') {
this.inActivity = false
} else {
this.inActivity = true
}
})


if (Window.isWX() && ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1) {

const cacheOpenId = Cookie.getCookie('session_wechat_user_openid')
let redirectUri = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/' + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/?' + qs.stringify(this.$route.query)



const authorizationURL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
(window.location.hostname === 'm.wkbins.com' ? 'wxef64cfa3a28363ac' : 'wx9594136eabd26d9f') + '&redirect_uri=' +
encodeURIComponent(redirectUri) + '&response_type=code&scope=snsapi_base#wechat_redirect'
if (cacheOpenId === null) {
if (code === null) {
window.location.href = authorizationURL
} else {
this.$http.get('/api/interface/getOpenIdByCode?code=' + code).then((response) => {
if (response.data.openid) {
this.codeOK = true
Cookie.setCookie('session_wechat_user_openid', response.data.openid)
} else {
window.location.href = authorizationURL
}
})
}
} else {
this.codeOK = true
}
} else {
this.codeOK = true
}

/**
* 不能写在mounted()中
*/
window.onload = this.onLoad
},
mounted () {
if (this.$store.state.config.title) {
document.title = this.$store.state.config.title
}
if (typeof window.onload === 'function') {
this.onLoad()
}
},
destroyed () {
window.$(document).off('click', '.nav li')
},
methods: {
play () {
this.audioIsPlaying = !this.audioIsPlaying
if (this.audioIsPlaying) {
this.$refs.audio.play()
this.playingHandler()
playAudioTimer = setInterval(() => {
this.playingHandler()
}, 1000)
} else {
this.$refs.audio.pause()
clearInterval(playAudioTimer)
}
},
playingHandler () {
this.currentAudioTime = this.$refs.audio.currentTime
if (this.$refs.audio.ended) {
this.audioIsPlaying = false
clearInterval(playAudioTimer)
}
},
getAudioDuration () {
this.currentAudioTime = this.$refs.audio.duration
},
openNewWindow (url) {
url = window.location.protocol + '//' + window.location.host + window.location.pathname + url
window.open(url)
},
openDetailDialog (title, content) {
this.showDetailDialog = true
this.detailDialogTitle = title
this.detailDialogTabs = []
this.detailDialogItems = []
this.currentDetailDialogIndex = 0
content.forEach((ele) => {
this.detailDialogTabs.push(ele.title)
this.detailDialogItems.push(ele.content)
})

},
closeDetailDialog () {
this.showDetailDialog = false

},
onClickBuy () {
console.log(123)
this.isShow = false

if (this.isDailiren && this.$route.query.haveQulification !== '1') {

location.href = '/agent/goApplyForGuohua?innerCode=' + this.$store.state.app.innerCode;
return
}
if (this.isNjx && this.$data.njxOffline) {
this.$vux.alert.show({
title: '产品升级',
content: '抱歉，产品升级维护中，您暂时无法购买，升级时间2018.6.20 23:00-2018.6.22 11:00',
buttonText: '我知道了',
onShow () {
}
})
return
}
if (!this.hasMeasure) {
if (this.hasNotify) {
this.$router.push({name: 'Notify', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode}, query: this.$route.query})
} else {
this.$router.push({name: this.$store.state.config.policy.path || 'Form', params: {productId: this.$store.state.order.productId, userId: this.$store.state.order.userId}, query: this.$route.query})
}
}
this.measureState = !this.measureState
if (!this.measureState) {
if (this.hasNotify) {
this.$router.push({name: 'Notify', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode}, query: this.$route.query})
} else {
this.$router.push({name: this.$store.state.config.policy.path || 'Form', params: {productId: this.$store.state.order.productId, userId: this.$store.state.order.userId}, query: this.$route.query})
}
}
},
onLoad () {

setTimeout(() => {
this.$nextTick(() => {
this.$refs.sticky.bindSticky()
})
}, 300)
/**
* 滚动页面
*/
let targets = []
window.$('.nav-target').each(function () {
targets.push(window.$(this)[0].offsetTop)
})

const navHeight = window.$('.nav').height()
const halfHeight = window.$(document).height() / 2
const scroller = this.$refs.scroller
const scrollBody = scroller.getScrollBody()
scrollBody.onscroll = () => {
targets = []
window.$('.nav-target').each(function () {
targets.push(window.$(this)[0].offsetTop)
})
const currentScrollTop = scroller.getScrollTop()
for (let i = targets.length - 1, l = 0; i >= l; i--) {
if (currentScrollTop < targets[0] - navHeight) {
window.$('.nav li').removeClass('active')
return
}

if (currentScrollTop >= targets[targets.length - 1] - navHeight - halfHeight) {
window.$('.nav li').removeClass('active')
window.$('.nav li').last().addClass('active')
return
}
if (currentScrollTop >= targets[i] - navHeight) {
window.$('.nav li').removeClass('active')
window.$('.nav li').eq(i).addClass('active')
return
}
}
}

window.$(document).on('click', '.nav li', function () {
scroller.scrollTo(targets[window.$(this).index()] - navHeight + 1)
})
},
jihuashuGuide () {
if (this.jihuashuGuideIndex < this.jihuashuGuideImgs.length - 1) {
this.jihuashuGuideIndex++
} else {

cookie.set('jihuashu', 'hasShowed', {
path: '/'
})
this.isJihuashuGuideClicked = true
}
},
checkAgentName () {
if (this.agentName === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入姓名',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkAgentJobNum () {
if (this.agentJobNum === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入工号',
position: 'top',
width: '20em'
})
return false
}
return true
},
onConfirmAgent () {
if (!this.checkAgentName() || !this.checkAgentJobNum()) return
this.showAgent = false
if (window.location.href.indexOf('agentCode') !== -1) {
window.location.href = window.location.href.replace(/agentCode.*?(?=(&|$))/, 'agentCode=' + encodeURIComponent(this.agentName + '|' + this.agentJobNum))
window.location.reload()
} else {
window.location.href = window.location.href + '&agentCode=' + encodeURIComponent(this.agentName + '|' + this.agentJobNum)
window.location.reload()
}
},
changeMessage (message) {
this.message = message
},
gotoMIndex () {
window.location.href = (window.location.hostname === 'm.wkbins.com' ? '/mall/index' : '/m') + this.urlsource
},
gotoMCat () {
window.location.href = '/m/products' + this.urlsource
},
gotoMCenter () {
window.location.href = '/weChat/personalCenter' + this.urlsource
}
}
}



// WEBPACK FOOTER //
// ./src/components/Index.vue